// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/5a278ade87456f5d548b4567.jpg",
  alt: "Oil portrait of an old dog sitting"
};

var pageTitle = "Custom Dog Portrait Painting";

var title = "Order a personalized";

var title2 = " oil painting of your dog";

var metaDescription = "Turn your dog photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.";

var description = "Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best artist to paint your dog. Whether you want a funny dog portrait, a cute puppy painting, or a classic portrait to honor the life of a special soul, we can help. All artworks are painted or drawn by hand in real life by a real artist, and shipped to your door.";

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Dogs Gallery",
  link: "/gallery/dog"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/5a6d6c1487456fbd298b456c.jpg?fp-z=3.15&fp-x=0.4&fp-y=0.3",
    imageAlt: "Portrait oil painting of a dog",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/60d2a866e495ecee188b456e.jpg?fp-z=1.9&fp-y=0.55",
    imageAlt: "Watercolor painting of a dog",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/608917f2e07b2965058b4567.jpg?fp-z=1.25&fp-y=0.6&fp-x=0.6",
    imageAlt: "Charcoal drawing of a pit bull",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/5de9a8e487456f17488b4584.jpg?fp-z=1.4&fp-y=0.4",
    imageAlt: "Pencil drawing of a small dog",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/59c34eb687456f7c1c8b4568.jpg?fp-z=2.2",
    imageAlt: "Colored pencil drawing of a dog",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Jackie",
    location: "Ozark",
    review: "I'm obsessed! Thanks Mr. Li.",
    link: "/products/gallery/custmixedmedia/5911ed0487456fd87f8b4568?order=1",
    image: "https://images.instapainting.com/591d84c687456f8b6f8b45b7_w0.jpg?fit=crop&crop=focalpoint&fp-y=.55&fp-z=2",
    imageAlt: "Portrait two pugs",
    date: new Date("5/25/2017")
  },
  {
    name: "Daniel",
    location: "Pasadena",
    review: "Beautiful! Thanks for the quick shipping.",
    link: "/products/gallery/custphotoreal/583d1ee887456f28658b458b/?order=1",
    image: "https://images.instapainting.com/584349df87456fd23b8b4568.jpg",
    imageAlt: "White haird dog on green grass Mixed-Media painting",
    date: new Date("12/05/2016")
  },
  {
    name: "Susan",
    location: "Napa",
    review: "Painting turned out great. Thank you!",
    link: "/products/gallery/custphotoreal/5820e2e987456f14258b456f/?order=1",
    image: "https://images.instapainting.com/5835088c87456fe8738b4567_w0.jpg",
    imageAlt: "Small dog outside on grass and dirt",
    date: new Date("11/22/2016")
  }
];

var contentBlocks = [
  {
    title1: "Hand-Painted Portrait of",
    title2: "Your Pooch",
    body: "Looking for a beautiful way to honor a dog that has passed away? Want to capture your dog’s personality in a fun and creative way? Or want to tell a memorable story in an exciting way that draws the attention of guests when they come to your home? Custom dog paintings are a great way to achieve any and all of this! With custom dog portraits, you can honor the furriest member of your household in the most special way possible.\n\nWhether you’re interested in dog paintings on canvas, a watercolor dog painting, an acrylic dog painting, or another type of painting, we’ll match you with interested artists and help you pick the right one to create it and ship it to you. We help you get the look and style you’re after with a beautiful one-of-a-kind personalized dog portrait.\n"
  },
  {
    title1: "Capture Your Cute Puppy",
    title2: "on Canvas",
    body: "There’s nothing quite like the bond you build with a beloved family dog who has been with you since puppyhood. Sadly, those sweet puppy days only last so long, and before you know it, that tiny, adorable face and ears quickly become a full-grown dog and all you can do is hold on to the memories. Fortunately, cute dog portraits are an excellent way to enjoy that moment in time just a little bit longer.\n\nOne of the best ways to capture that puppy cuteness forever is to commission a talented artist to paint a puppy portrait of your precious fur baby. All of our dog portraits are real, handmade artworks created by living, professional artists. So you can expect top quality work, communication throughout the process, and unlimited revisions until you get the cute puppy painting you envision and desire.\n"
  },
  {
    title1: "Turn a Funny Photo into a",
    title2: "Cherished Memory",
    body: "You know that one photo of your dog that you always go back to when you need a laugh? Or the hilarious picture of your dog that warms your heart and gives you all the feels when you look at it? Those pictures are some of the best ones to turn into art! So why not commission a dog portrait artist to create a beautiful, handmade work of art that you will cherish for a lifetime?\n\nFunny dog portraits are a great way to memorialize a pet that has recently passed away, give a friend a unique and memorable gift, or decorate an area of your home that will be a great conversation starter. Every time you look at the funny dog portrait of your pup, you’ll be reminded of a special memory and a precious pup that changed your heart forever. \n\nFunny dog portraits are more than just a great way to decorate your home—they’re meaningful and creative ways to capture a special moment in time that will forever bring you joy, happiness, and a good belly laugh."
  },
  {
    title1: "",
    title2: "Start by Uploading Your Photo Today",
    body: "If you’re searching for a dog portrait artist to recreate the essence of your wonderful pup, look no further than Instapainting. We help you get a beautiful custom dog portrait that perfectly matches your preferences and style. When you commission an artist through Instapainting, you can rest easy knowing that we’ll streamline the process and can guarantee your satisfaction with the end result. Don’t believe us? Just check out our incredible customer reviews to see for yourself. We work with a team of skilled and masterful artists that will create one-of-a-kind dog portraits from pictures in less than three weeks’ time.\n\nWhen you’re ready to place your order, simply start by selecting an artwork product type, upload a photo of your precious fur baby, add instructions, and submit the order! From there, we’ll help you by matching you with interested artists who can provide the type of artwork and style you want, help you pick the best one, and then your custom dog portrait will be on its way to you in no time! And the best part? You get unlimited revisions to ensure that the final product is everything you hoped for and dreamed of. Could it get any better than that? Get started today by uploading your pup’s picture!"
  }
];

function DogPaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = DogPaintingsPage;

var $$default = DogPaintingsPage;

export {
  heroImg ,
  pageTitle ,
  title ,
  title2 ,
  metaDescription ,
  description ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
